import { Shield, Lock } from 'lucide-react';
import { useThemeMode } from '../../theme/ThemeProvider';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { isDark } = useThemeMode();

  return (
    <footer
      className={[
        // Hidden on mobile — it only ate ~56px of screen on every page.
        'w-full px-3 sm:px-8 hidden sm:flex items-center justify-between gap-2 transition-all duration-500 relative overflow-hidden min-h-[56px]',
        isDark ? 'bg-dark-chrome-footer/95 shadow-dark-footer' : 'bg-white/[0.85]',
      ].join(' ')}
      style={{
        backdropFilter: 'blur(24px) saturate(1.4)',
        WebkitBackdropFilter: 'blur(24px) saturate(1.4)',
      }}
    >
      {/* Top border — gradient line for visual separation from content */}
      <div
        className={[
          'absolute top-0 left-0 right-0 h-px pointer-events-none',
          isDark
            ? 'bg-gradient-to-r from-dark-border-glow via-dark-border to-dark-border-glow'
            : 'bg-gradient-to-r from-transparent via-light-border to-transparent',
        ].join(' ')}
      />

      {/* Left: Trust badges + copyright */}
      <div className="flex min-w-0 items-center gap-1.5 sm:gap-3">
        {/* HIPAA badge */}
        <div
          className={[
            'flex flex-shrink-0 items-center gap-1 sm:gap-1.5 px-2 sm:px-2.5 py-1 sm:py-1.5 rounded-lg transition-all duration-200 hover:scale-105',
            isDark
              ? 'bg-dark-accent-emerald border border-dark-accent-emerald-border'
              : 'bg-light-accent-emerald border border-light-accent-emerald-border',
          ].join(' ')}
        >
          <Shield size={13} strokeWidth={2.2} className={"text-emerald-600/80 dark:text-emerald-400"} />
          <span className={[
            'text-caption-sm font-bold uppercase tracking-[0.06em] sm:tracking-[0.1em] whitespace-nowrap',
            "text-emerald-700/80 dark:text-emerald-300",
          ].join(' ')}>
            HIPAA
          </span>
        </div>

        {/* Encryption badge */}
        <div
          className={[
            'flex flex-shrink-0 items-center gap-1 sm:gap-1.5 px-2 sm:px-2.5 py-1 sm:py-1.5 rounded-lg transition-all duration-200 hover:scale-105',
            isDark
              ? 'bg-dark-accent-brand-subtle border border-dark-accent-brand-border'
              : 'bg-light-accent-brand border border-light-accent-brand-border',
          ].join(' ')}
        >
          <Lock size={13} strokeWidth={2.2} className={"text-brand-500/75 dark:text-brand-300"} />
          <span className={[
            'text-caption-sm font-bold uppercase tracking-[0.06em] sm:tracking-[0.1em] whitespace-nowrap',
            "text-brand-600/70 dark:text-brand-300",
          ].join(' ')}>
            256-bit
          </span>
        </div>

        {/* Separator */}
        <div className={[
          'hidden sm:block w-px h-3.5',
          isDark ? 'bg-white/[0.10]' : 'bg-slate-200/70',
        ].join(' ')} />

        {/* Copyright */}
        <p className={[
          'hidden sm:block text-caption-sm font-semibold',
          "text-slate-500 dark:text-slate-300",
        ].join(' ')}>
          &copy; {currentYear} Symbian Health
        </p>
      </div>

      {/* Right: Links */}
      <div className="flex flex-shrink-0 items-center gap-3 sm:gap-4">
        <a
          href="/privacy-policy"
          className={[
            'text-caption-sm font-semibold transition-all duration-200 hover:underline underline-offset-2',
            isDark
              ? 'text-slate-300 hover:text-brand-300'
              : 'text-slate-500 hover:text-brand-500',
          ].join(' ')}
        >
          Privacy
        </a>
        <div className={['w-px h-3.5', isDark ? 'bg-white/[0.10]' : 'bg-slate-200/60'].join(' ')} />
        <a
          href="/terms-conditions"
          className={[
            'text-caption-sm font-semibold transition-all duration-200 hover:underline underline-offset-2',
            isDark
              ? 'text-slate-300 hover:text-brand-300'
              : 'text-slate-500 hover:text-brand-500',
          ].join(' ')}
        >
          Terms
        </a>
      </div>
    </footer>
  );
}

export default Footer;
